/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ActivityResponse } from '../models/activity-response';
import { activityWellDone } from '../fn/activity/activity-well-done';
import { ActivityWellDone$Params } from '../fn/activity/activity-well-done';
import { BooleanResponse } from '../models/boolean-response';
import { createActivity } from '../fn/activity/create-activity';
import { CreateActivity$Params } from '../fn/activity/create-activity';
import { deleteActivityById } from '../fn/activity/delete-activity-by-id';
import { DeleteActivityById$Params } from '../fn/activity/delete-activity-by-id';
import { getActivityAdmins } from '../fn/activity/get-activity-admins';
import { GetActivityAdmins$Params } from '../fn/activity/get-activity-admins';
import { getActivityById } from '../fn/activity/get-activity-by-id';
import { GetActivityById$Params } from '../fn/activity/get-activity-by-id';
import { getMultipleActivitiesById } from '../fn/activity/get-multiple-activities-by-id';
import { GetMultipleActivitiesById$Params } from '../fn/activity/get-multiple-activities-by-id';
import { getRandomActivities } from '../fn/activity/get-random-activities';
import { GetRandomActivities$Params } from '../fn/activity/get-random-activities';
import { patchActivityById } from '../fn/activity/patch-activity-by-id';
import { PatchActivityById$Params } from '../fn/activity/patch-activity-by-id';
import { sendNotificationActivityCreate } from '../fn/activity/send-notification-activity-create';
import { SendNotificationActivityCreate$Params } from '../fn/activity/send-notification-activity-create';
import { updateActivityById } from '../fn/activity/update-activity-by-id';
import { UpdateActivityById$Params } from '../fn/activity/update-activity-by-id';
import { updateActivityLogoById } from '../fn/activity/update-activity-logo-by-id';
import { UpdateActivityLogoById$Params } from '../fn/activity/update-activity-logo-by-id';
import { UserTag } from '../models/user-tag';
import { WellDoneResponse } from '../models/well-done-response';

@Injectable({ providedIn: 'root' })
export class ActivityService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createActivity()` */
  static readonly CreateActivityPath = '/rest/activity';

  /**
   * Create new activity.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createActivity()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createActivity$Response(params: CreateActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<ActivityResponse>> {
    return createActivity(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new activity.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createActivity$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createActivity(params: CreateActivity$Params, context?: HttpContext): Observable<ActivityResponse> {
    return this.createActivity$Response(params, context).pipe(
      map((r: StrictHttpResponse<ActivityResponse>): ActivityResponse => r.body)
    );
  }

  /** Path part for operation `getActivityById()` */
  static readonly GetActivityByIdPath = '/rest/activity/{id}';

  /**
   * Get single event.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActivityById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActivityById$Response(params: GetActivityById$Params, context?: HttpContext): Observable<StrictHttpResponse<ActivityResponse>> {
    return getActivityById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get single event.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActivityById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActivityById(params: GetActivityById$Params, context?: HttpContext): Observable<ActivityResponse> {
    return this.getActivityById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ActivityResponse>): ActivityResponse => r.body)
    );
  }

  /** Path part for operation `updateActivityById()` */
  static readonly UpdateActivityByIdPath = '/rest/activity/{id}';

  /**
   * Update existing event (activity).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateActivityById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateActivityById$Response(params: UpdateActivityById$Params, context?: HttpContext): Observable<StrictHttpResponse<ActivityResponse>> {
    return updateActivityById(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing event (activity).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateActivityById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateActivityById(params: UpdateActivityById$Params, context?: HttpContext): Observable<ActivityResponse> {
    return this.updateActivityById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ActivityResponse>): ActivityResponse => r.body)
    );
  }

  /** Path part for operation `deleteActivityById()` */
  static readonly DeleteActivityByIdPath = '/rest/activity/{id}';

  /**
   * Delete activity by id (if activity has been deleted, nothing will change).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteActivityById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteActivityById$Response(params: DeleteActivityById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteActivityById(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete activity by id (if activity has been deleted, nothing will change).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteActivityById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteActivityById(params: DeleteActivityById$Params, context?: HttpContext): Observable<void> {
    return this.deleteActivityById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchActivityById()` */
  static readonly PatchActivityByIdPath = '/rest/activity/{id}';

  /**
   * Patch existing activity.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchActivityById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchActivityById$Response(params: PatchActivityById$Params, context?: HttpContext): Observable<StrictHttpResponse<ActivityResponse>> {
    return patchActivityById(this.http, this.rootUrl, params, context);
  }

  /**
   * Patch existing activity.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchActivityById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchActivityById(params: PatchActivityById$Params, context?: HttpContext): Observable<ActivityResponse> {
    return this.patchActivityById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ActivityResponse>): ActivityResponse => r.body)
    );
  }

  /** Path part for operation `getActivityAdmins()` */
  static readonly GetActivityAdminsPath = '/rest/activity/{id}/admins';

  /**
   * Get activity admins (required is logged user, user must be admin of activity).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActivityAdmins()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActivityAdmins$Response(params: GetActivityAdmins$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserTag>>> {
    return getActivityAdmins(this.http, this.rootUrl, params, context);
  }

  /**
   * Get activity admins (required is logged user, user must be admin of activity).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActivityAdmins$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActivityAdmins(params: GetActivityAdmins$Params, context?: HttpContext): Observable<Array<UserTag>> {
    return this.getActivityAdmins$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserTag>>): Array<UserTag> => r.body)
    );
  }

  /** Path part for operation `updateActivityLogoById()` */
  static readonly UpdateActivityLogoByIdPath = '/rest/activity/{id}/logo';

  /**
   * Update existing activity logo by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateActivityLogoById()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateActivityLogoById$Response(params: UpdateActivityLogoById$Params, context?: HttpContext): Observable<StrictHttpResponse<ActivityResponse>> {
    return updateActivityLogoById(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing activity logo by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateActivityLogoById$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateActivityLogoById(params: UpdateActivityLogoById$Params, context?: HttpContext): Observable<ActivityResponse> {
    return this.updateActivityLogoById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ActivityResponse>): ActivityResponse => r.body)
    );
  }

  /** Path part for operation `activityWellDone()` */
  static readonly ActivityWellDonePath = '/rest/activity/{id}/well-done';

  /**
   * User must be logged to call this service. Logged user will clap with hands - add well done to activity. There is maximum of well done which user can give to activity. After that count is not anymore increased.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activityWellDone()` instead.
   *
   * This method doesn't expect any request body.
   */
  activityWellDone$Response(params: ActivityWellDone$Params, context?: HttpContext): Observable<StrictHttpResponse<WellDoneResponse>> {
    return activityWellDone(this.http, this.rootUrl, params, context);
  }

  /**
   * User must be logged to call this service. Logged user will clap with hands - add well done to activity. There is maximum of well done which user can give to activity. After that count is not anymore increased.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `activityWellDone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  activityWellDone(params: ActivityWellDone$Params, context?: HttpContext): Observable<WellDoneResponse> {
    return this.activityWellDone$Response(params, context).pipe(
      map((r: StrictHttpResponse<WellDoneResponse>): WellDoneResponse => r.body)
    );
  }

  /** Path part for operation `sendNotificationActivityCreate()` */
  static readonly SendNotificationActivityCreatePath = '/rest/activity/{id}/send-notification-create';

  /**
   * Activity administrator can send email (notification) about new activity (creation) to all followers (users) of activity organizers. Send of notification is ASYNC event and can take a few seconds.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendNotificationActivityCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendNotificationActivityCreate$Response(params: SendNotificationActivityCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
    return sendNotificationActivityCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Activity administrator can send email (notification) about new activity (creation) to all followers (users) of activity organizers. Send of notification is ASYNC event and can take a few seconds.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendNotificationActivityCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendNotificationActivityCreate(params: SendNotificationActivityCreate$Params, context?: HttpContext): Observable<BooleanResponse> {
    return this.sendNotificationActivityCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BooleanResponse>): BooleanResponse => r.body)
    );
  }

  /** Path part for operation `getMultipleActivitiesById()` */
  static readonly GetMultipleActivitiesByIdPath = '/rest/activity/get-all/{ids}';

  /**
   * Get multiple activities by ids - ids are defined as parameter, separated by '','' (like ''165,132,12''). If not number value is passed (like ''156,13,12A,25'') - value is ignored.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMultipleActivitiesById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMultipleActivitiesById$Response(params: GetMultipleActivitiesById$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityResponse>>> {
    return getMultipleActivitiesById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get multiple activities by ids - ids are defined as parameter, separated by '','' (like ''165,132,12''). If not number value is passed (like ''156,13,12A,25'') - value is ignored.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMultipleActivitiesById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMultipleActivitiesById(params: GetMultipleActivitiesById$Params, context?: HttpContext): Observable<Array<ActivityResponse>> {
    return this.getMultipleActivitiesById$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ActivityResponse>>): Array<ActivityResponse> => r.body)
    );
  }

  /** Path part for operation `getRandomActivities()` */
  static readonly GetRandomActivitiesPath = '/rest/activity/get-random/{count}';

  /**
   * Get random activities - count of returned activities is path parameter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRandomActivities()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRandomActivities$Response(params: GetRandomActivities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityResponse>>> {
    return getRandomActivities(this.http, this.rootUrl, params, context);
  }

  /**
   * Get random activities - count of returned activities is path parameter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRandomActivities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRandomActivities(params: GetRandomActivities$Params, context?: HttpContext): Observable<Array<ActivityResponse>> {
    return this.getRandomActivities$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ActivityResponse>>): Array<ActivityResponse> => r.body)
    );
  }

}
